import React from 'react';
import tw, { styled } from 'twin.macro';
import { motion } from 'framer-motion';
import { Container as ContainerBase, Content2Xl } from "components/misc/Layouts.js";
import { SectionHeadingH2 } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";


const Container = styled(ContainerBase)`
  padding: 3rem 0;
  padding-bottom: 2rem;
`;

const Content = styled(Content2Xl)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Description = styled(motion.p)`
  ${tw`text-lg lg:text-xl text-gray-700 leading-relaxed mb-12 text-center max-w-4xl mx-auto`}
  padding: 2rem 0;
  position: relative;
  
  &::before, &::after {
    content: '';
    position: absolute;
    left: 50%;
    width: 100px;
    height: 1px;
    background-color: #e0e0e0;
    transform: translateX(-50%);
  }
  
  &::before {
    top: 0;
  }
  
  &::after {
    bottom: 0;
  }
`;
const DeveloperResources = ({ translations }) => {
  const { heading, description } = translations.devCommunity.why;
  
  return (
    <Container>
      <Content>
        <Description
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {description}
        </Description>
      </Content>
    </Container>
  );
};

export default DeveloperResources;